/**
 * Canonical ids for user-configurable global keyboard shortcuts.
 * Defaults match the historical hardcoded bindings.
 */
export const HOTKEY_IDS = {
  quickSearch: 'global.quickSearch',
  feedback: 'global.feedback',
  aiAssistant: 'global.aiAssistant',
} as const;

export type HotkeyId = (typeof HOTKEY_IDS)[keyof typeof HOTKEY_IDS];

export interface HotkeyDefinition {
  id: HotkeyId;
  /** react-hotkeys-hook combo, e.g. "mod+k" */
  defaultKeys: string;
}

export const HOTKEY_REGISTRY: readonly HotkeyDefinition[] = [
  {
    id: HOTKEY_IDS.quickSearch,
    defaultKeys: 'mod+k',
  },
  {
    id: HOTKEY_IDS.feedback,
    defaultKeys: 'mod+shift+f',
  },
  {
    id: HOTKEY_IDS.aiAssistant,
    defaultKeys: 'mod+shift+a',
  },
] as const;

const DEFAULT_KEYS_BY_ID: Record<HotkeyId, string> = Object.fromEntries(
  HOTKEY_REGISTRY.map((entry) => [entry.id, entry.defaultKeys]),
) as Record<HotkeyId, string>;

export function getDefaultHotkeyKeys(id: HotkeyId): string {
  return DEFAULT_KEYS_BY_ID[id];
}

export function isHotkeyId(value: string): value is HotkeyId {
  return value in DEFAULT_KEYS_BY_ID;
}
